export default __webpack_public_path__ + "static/output-8088d2d4bff15fda28f1c9c0c4902e80.jpg";